import React from "react"
import PropTypes from "prop-types"
import { toggleGenericFilter } from "shared/search/containers/Filter/FilterCreators"

export const CustomDataGeographicOrAggregateFilter = (props) => {
    const FilterComponent = props.filterComponent || toggleGenericFilter
    return <FilterComponent {...props} />
}
CustomDataGeographicOrAggregateFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    displayLabel: PropTypes.string,
    trueText: PropTypes.string,
    falseText: PropTypes.string,
}
CustomDataGeographicOrAggregateFilter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "CustomDataGeographicOrAggregateFilter",
    filterKey: "geographic_or_aggregate",
    trueText: "Aggregate",
    falseText: "Geographic",
}
